var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlertInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 2.52781C5.10999 2.52781 1.95652 5.68128 1.95652 9.57129C1.95652 13.4613 5.10999 16.6148 9 16.6148C12.89 16.6148 16.0435 13.4613 16.0435 9.57129C16.0435 5.68128 12.89 2.52781 9 2.52781ZM0 9.57129C0 4.60073 4.02944 0.571289 9 0.571289C13.9706 0.571289 18 4.60073 18 9.57129C18 14.5419 13.9706 18.5713 9 18.5713C4.02944 18.5713 0 14.5419 0 9.57129Z",
    fill: "#6171FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.02174 8.00607C9.1023 8.00607 9.97826 8.88204 9.97826 9.96259V13.2887C9.97826 13.829 9.54028 14.2669 9 14.2669C8.45972 14.2669 8.02174 13.829 8.02174 13.2887V8.00607Z",
    fill: "#6171FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1739 6.04955C10.1739 6.69788 9.64833 7.22346 9 7.22346C8.35167 7.22346 7.82609 6.69788 7.82609 6.04955C7.82609 5.40122 8.35167 4.87564 9 4.87564C9.64833 4.87564 10.1739 5.40122 10.1739 6.04955Z",
    fill: "#6171FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertInfo);
export default __webpack_public_path__ + "static/media/alert-info.ea8f0113.svg";
export { ForwardRef as ReactComponent };